export const PAINTING_SET_MEDIUM = 'PAINTING_SET_MEDIUM';
export const paintingSetMedium = (medium) => ({ type: PAINTING_SET_MEDIUM, payload: medium });

export const PAINTING_SET_FORCE = 'PAINTING_SET_FORCE';
export const paintingSetForce = (force) => ({ type: PAINTING_SET_FORCE, payload: force });

export const PAINTING_SET_GET_FORCE_FROM_PEN = 'PAINTING_SET_GET_FORCE_FROM_PEN';
export const paintingSetGetForceFromPen = (logic) => ({ type: PAINTING_SET_GET_FORCE_FROM_PEN, payload: logic });
